var helper = require('../../helper');
require('moment');
require('jquery-ui');
require('jquery-ui/ui/widgets/draggable');

var InspectionCalendarOfBuildingManagerController = function(datatable, lunchAddModal) {

    this.datatable = datatable;
    this.userId = $('#js-user-id').data('user');
    this.calendar = $('#inspections-calendar-building-manager');
    this.$modal = $('#edit-inspection-of-building-manager');
    this.$updateButton = this.$modal.find('.modal-submit-button');
    this.$deleteButton = this.$modal.find('.js-modal-delete-button');
	this.$propertiesWrapper = $('div.event-in-filter');
	this.$filterBuildingManagerSelect = $('#calendar_bm_filter_bm_select');
	this.$inspectionTypeIdToAdd = $('#calendar_inspection_type_id_to_add');

	this.$scheduleRandomly = $('#schedule_randomly_monthly_inspections');

    this.EditModalFormController = new (require('../../services/modals/ModalFormController'))(this.$modal);
    this.InspectionCalendarController = new (require('../../modules/inspections/InspectionCalendarController'))();
    this.ToastrController = new (require('../../services/ToastrController'));

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    (function()
    {

        self.$updateButton.click(function(e){
            self.updateModel(e);
        });

        self.$deleteButton.click(function(e){
            self.deleteModel(e);
        });

	    self.$filterBuildingManagerSelect.change(function(e){
		    self.filterPropertiesByBuildingManager(this, e);
	    });

	    self.$scheduleRandomly.click(function(e){
	    	console.log('clicked schedule Randomly');
		    self.scheduleRandomly();
	    });

	    self.generateDraggableElements();

    }());

}

InspectionCalendarOfBuildingManagerController.prototype.render = function(message, title) {

    var self = this;

    this.calendar.fullCalendar('destroy');

    this.calendar.fullCalendar({
        events: helper.getOrigin() + "/api/inspections/building-manager/" + this.userId,
        header: {
            left: '',
            center: 'prev title next',
            right: 'listWeek,month,agendaWeek,agendaDay'
        },
        defaultView: 'listWeek',
        timeFormat: 'HH:mm',
        axisFormat: 'HH:mm',
        firstHour: 9,
        firstDay: 1,
        minTime: '07:00',
        displayEventEnd: true,
	    editable: true,
	    droppable: true,
	    dropAccept: 'div.draggable-element',

	    dayRender: function (date, cell) {

        	var route = $('#route-day-'+date.format('YYYY-MM-DD'));

			if(route){
				cell.append(route.html());
			} else{

				/** Add event when dropped */
				$.ajax({
					url: '/api/inspections/calendar/routeForDay',
					data: {
						date: (date.format('YYYY-MM-DD HH:mm:ss')),
						buildingManagerId: self.userId
					},
					type: 'POST',
					dataType: 'json',
					success: function (response) {
						console.log(response);
						cell.append(response);
					},
					error: function (e) {
						console.log('Error' + e);
					}
				})

			}


	    },

        eventClick: function (event) {

            var  fields = ['id', 'property_id', 'property_title', 'type_id', 'day', 'time_from', 'time_to', 'description', 'updated_at'];

            self.getModel(event.id, function(model){

                self.EditModalFormController.loadInspectionData(model, fields) // my modal

                self.EditModalFormController.showModal(); // on CALLBACK!
            });

        },

	    drop: function (date) {

		    // retrieve the dropped element's stored Event Object
		    var originalEventObject = $(this).data('eventObject');

		    // we need to copy it, so that multiple events don't have a reference to the same object
		    var copiedEventObject = $.extend({}, originalEventObject);
		    copiedEventObject.start = date.format("DD/MM/YYYY HH:mm");
		    copiedEventObject.end = date.format("DD/MM/YYYY HH:mm");
		    copiedEventObject.id = $(this).data('id');
		    copiedEventObject.type = $(this).data('type');

		    /** Add event when dropped */
		    $.ajax({
			    url: '/api/inspections/calendar/add',
			    data: {
				    type: copiedEventObject.type,
				    start: copiedEventObject.start,
				    end: copiedEventObject.end,
				    id: copiedEventObject.id,
				    building_manager_id: self.userId,
				    type_id: self.$inspectionTypeIdToAdd.val(),
			    },
			    type: 'POST',
			    dataType: 'json',
			    success: function (response) {
				    var result = response.result;

				    if(Array.isArray(result)){

					    for (var i=0; i < result.length; i++) {
						    self.calendar.fullCalendar('renderEvent', result[i], true);
					    }


				    } else{
					    self.calendar.fullCalendar('renderEvent', result, true);
				    }

			    },
			    error: function (e) {
				    console.log('Error' + e);
			    }
		    });
	    },

	    eventDragStop: function (event, jsEvent) {

		    var trashEl = $('#calendarTrash');
		    var ofs = trashEl.offset();

		    var x1 = ofs.left;
		    var x2 = ofs.left + trashEl.outerWidth(true);
		    var y1 = ofs.top;
		    var y2 = ofs.top + trashEl.outerHeight(true);

		    if (jsEvent.pageX >= x1 && jsEvent.pageX <= x2 &&
				    jsEvent.pageY >= y1 && jsEvent.pageY <= y2) {

			    /** Destroy event when dropped onto thrash icon */
			    $.ajax({
				    url: '/api/inspections/delete/'+event.id,
				    data: {
					    id: event.id
				    },
				    type: 'POST',
				    dataType: 'json',
				    success: function (response) {
					    if (response.status == 'success'){

						    self.calendar.fullCalendar('removeEvents', event.id);

					    } else {

						    console.log('An error has occurred while trying to delete a ticket.');
					    }
				    },
				    error: function (e) {
					    console.log('Error' + e);
				    }
			    });
		    }

	    },

	    eventDrop: function (event, jsEvent, ui, view) {
		    self.reschedule(event);
	    },

	    eventResize: function (event, jsEvent, ui, view) {
		    self.reschedule(event);
	    },
    });

    self.datatable.reload();
}

InspectionCalendarOfBuildingManagerController.prototype.deleteModel = function(e) {

    var msg = 'Are you sure you want to delete this?';

    if (!confirm(msg)) {
        e.preventDefault();
        return;
    }

    e.preventDefault();

    this.InspectionCalendarController.deleteModel(this, this.EditModalFormController);
}

InspectionCalendarOfBuildingManagerController.prototype.filterPropertiesByBuildingManager = function(filterBuildingManagerSelect, e) {

	var $filterBuildingManagerSelect = $(filterBuildingManagerSelect),
			buildingManagerId = $filterBuildingManagerSelect.val(),
			$properties = $('.event-in-filter'),
			$propertiesOfBuildingManager = $('.event-in-filter[data-building-manager-id="'+buildingManagerId+'"]');

	console.log('filter contact select change');

	// hide all
	$properties.hide();

	if(buildingManagerId == 0){  // if 0 -> show all

		$properties.show();

	} else if(buildingManagerId == -1){ // if -1 -> show unassigned

		$('.event-in-filter[data-building-manager-id=""]').show();

	} else{ // else -> show chosen

		$propertiesOfBuildingManager.show();
	}

}

InspectionCalendarOfBuildingManagerController.prototype.generateDraggableElements = function() {

	$('div.draggable-element').each(function () {

		// it doesn't need to have a start or end
		var eventObject = {
			title: $.trim($(this).text()), // use the element's text as the event title
			type: $.trim($(this).data('type'))
		};

		// store the Event Object in the DOM element so we can get to it later
		$(this).data('eventObject', eventObject);

		// make the event draggable using jQuery UI
		$(this).draggable({
			//		zIndex: 999,
			revert: true, // will cause the event to go back to its
			revertDuration: 0 // original position after the drag
		});
	});
}

InspectionCalendarOfBuildingManagerController.prototype.updateModel = function(e) {
    e.preventDefault();
    this.InspectionCalendarController.updateModel(this, this.EditModalFormController);
}

InspectionCalendarOfBuildingManagerController.prototype.getModel = function(modelId, callbackSuccess) {
    return this.InspectionCalendarController.getModel(modelId, callbackSuccess);
}

InspectionCalendarOfBuildingManagerController.prototype.getFormData = function(unindexed_array) {
    return this.InspectionCalendarController.getFormData(unindexed_array);
}

InspectionCalendarOfBuildingManagerController.prototype.reschedule = function(event) {
	this.InspectionCalendarController.reschedule(event, this.calendar);
}

InspectionCalendarOfBuildingManagerController.prototype.scheduleRandomly = function() {

	var $month = $('#random_month').val(),
		$year = $('#random_year').val(),
		$errorDiv = $('#random_error');

	// console.log('schedule Randomly function');

	$errorDiv.html('Inspection will be scheduled (in the background)! Refresh the page soon to see the changes.');

	$.ajax({
		url: '/api/inspections/schedule-randomly',
		data: {
			month: $month,
			year: $year,
			building_manager_id: this.userId
		},
		type: 'POST',
		dataType: 'json',
		success: function (response) {
			if (response.status == 'success'){

			//	location.reload();

				// console.log('schedule success');
				// console.log(response);

				$errorDiv.html(response.message);

			} else {
				// console.log('schedule error');
				$errorDiv.html(response.message);
			}
		},
		error: function (e) {
			console.log('Error' + e);
		}
	});

}

InspectionCalendarOfBuildingManagerController.prototype.clearModal = function() {
    this.EditModalFormController.clearModal();
}

InspectionCalendarOfBuildingManagerController.prototype.showModal = function() {
    this.EditModalFormController.showModal();
}

InspectionCalendarOfBuildingManagerController.prototype.closeModal = function() {
    this.EditModalFormController.closeModal();
}

module.exports = InspectionCalendarOfBuildingManagerController;
